/**
 * Wallet apps that open this page in their own browser, where they inject the wallet the page
 * connects to as it does on desktop: a phone's browser has none. Each link is the app's documented
 * universal link. Only apps that can switch to HyperEVM (999) for papertrade's signatures and to
 * Arbitrum for a deposit's are listed; Phantom does not let a page use HyperEVM yet.
 */
export type WalletApp = { name: string; link: (url: string) => string };

export const walletApps: WalletApp[] = [
  // metamask.app.link/dapp/ and the address without its scheme (MetaMask's deeplink generator).
  { name: "MetaMask", link: (url) => `https://metamask.app.link/dapp/${url.replace(/^https?:\/\//, "")}` },
  // The address percent-encoded in cb_url (Coinbase's mobile dapp integration docs).
  { name: "Coinbase Wallet", link: (url) => `https://go.cb-w.com/dapp?cb_url=${encodeURIComponent(url)}` },
  // The DApp browser route, coin_id 60 for Ethereum's addresses (Trust Wallet's deep linking docs).
  {
    name: "Trust Wallet",
    link: (url) => `https://link.trustwallet.com/open_url?coin_id=60&url=${encodeURIComponent(url)}`,
  },
];

/** A phone or tablet, iPads that call themselves Macs included. */
export function isMobile(): boolean {
  if (typeof navigator === "undefined") return false;
  if (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) return true;
  return /Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1;
}

/** Whether the browser carries a wallet of its own: a wallet app's browser does, a phone's does not. */
export function hasInjectedWallet(): boolean {
  return typeof window !== "undefined" && "ethereum" in window && Boolean((window as { ethereum?: unknown }).ethereum);
}
